var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lazy-image-wrapper",style:({ paddingBottom: _vm.aspectRatio })},[(!_vm.loaded)?_c('div',{staticClass:"skeleton-loader"}):_vm._e(),(_vm.intersected)?_c('img',{class:{ loaded: _vm.loaded },attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onImageLoad}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }